import { getModalStore } from './_getModalStore'

const useCustomOfferModalStore = getModalStore('custom-offer-modal')

export default useCustomOfferModalStore
